import { hydrate, observe } from "@modules/hydrate/hydrate";
import initLenis from "@modules/lenis/initLenis";
import initDashedBorder from "@modules/dashedBorder/dashedBorder";
import { warmLottie } from "@components/lottie/lottie";
import HeaderNav from "@common/header-nav/header-nav";

HeaderNav();
hydrate();
observe();
initDashedBorder();
warmLottie();

initLenis().catch((error) => {
    console.error("[Lenis] Failed to initialize", error);
});